module.exports = __webpack_public_path__ + "img/6.17bfac0b.png";